
import bngexitButtonAst from "../../../../../../assets/games/bingo/exit.png";
import { useSelector } from "react-redux";

import   "./bingo.css"


const BottomButtonPanel = (props) => {
    const language = useSelector((state) => state.languageObjs.languageObj)

    return(
        <div className="infotext-exit-container">
            {/* <div className="bottom-container">
                <img className="bottom-container-infotext-img" src= {bngInfotextAst}/>
                <h1 className="infotext-heading">{props.infoText}</h1>
            </div> */}

            

        </div>
    )
}

export default BottomButtonPanel





